class Popup {
    constructor(element) {
        // Find all necessary elements
        this.element = element;

        // SessionStoreage
        const isAtivePopup = sessionStorage.getItem('itc-popup');

        console.log(isAtivePopup);

        // Init functionalities if all elements has been found
        if (this.element && isAtivePopup === null) {
            this.init();
        } else {
            console.error("missing elements to properly init Popup")
        }
    }

    init() {
        console.log('popup');

        this.element.classList.add('active');

        const btnClose = this.element.querySelector(`[data-popup="close"]`);

        if (btnClose) {
            btnClose.addEventListener('click', (e) => {
                e.preventDefault();
                this.element.classList.remove('active');
                sessionStorage.setItem('itc-popup', true);
            })
        }
    }
}


window.addEventListener('load', () => {

    const popupWrappers = document.querySelectorAll(`[data-popup="true"]`);

    popupWrappers.forEach((wrapper) => {
        new Popup(wrapper);
    })

    // $(".btnYes").click(function (event) {
    //     event.preventDefault();
    //     //setCookie("modalhome", true, 256);
    //     $('main').removeClass('accessHide');
    //     $('.accessPopup').css('display', 'none');
    // });
});